import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=3576be2c"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Link: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/link/Link.vue').default,Loader: require('/home/runner/work/platform/platform/packages/client/src/components/utils/loader/Loader.vue').default,Button: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/button/Button.vue').default,Empty: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/empty/Empty.vue').default,Content: require('/home/runner/work/platform/platform/packages/client/src/components/elements/base/content/Content.vue').default,Brochureware: require('/home/runner/work/platform/platform/packages/client/src/components/layouts/brochureware/Brochureware.vue').default})
